// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".linkedTabsItem[data-v-c00cd63a]{width:100%}.linkedTabsItem a[data-v-c00cd63a]{color:#fdfdfd;display:block;outline:none;text-align:center;-webkit-text-decoration:none;text-decoration:none;transition:all .3s}@media(min-width:768px){.linkedTabsItem a[data-v-c00cd63a]{font-size:1rem}}.linkedTabsItem a[disabled][data-v-c00cd63a]{cursor:default;opacity:.5;pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
